import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './router/index'
import { createStore } from 'vuex'
import stores from './store/index'
import 'bootstrap';
import '@/assets/css/bootstrap.css'
import '@/assets/js/bootstrap.js'
import '@/assets/css/modern.css'
import '@/assets/css/baseStyle.css'
//語系
import { createI18n } from 'vue-i18n'
// import zh from './i18n/'      // 存放中文語系檔
import en from './i18n/en.json'      // 存放英文語系檔
import tw from './i18n/tw.json'      // 存放英文語系檔
import cn from './i18n/cn.json'      // 存放英文語系檔
import vi from './i18n/vi.json'      // 存放英文語系檔
import ja from './i18n/ja.json'      // 存放英文語系檔
import Language from './assets/js/language/language'
//使用者用
import User from '@/assets/js/user.js'
import ApiService from '@/assets/js/apiService'
import shareds from '@/assets/js/shared'
const language = Language.getInstance();
console.log("process.env.BASE_URL = ",process.env.BASE_URL)
console.log('process.env.VUE_APP_BASE_APP_PATH:', process.env.VUE_APP_BASE_APP_PATH);
console.log('process.env.VUE_APP_BASE_APP_URL:', process.env.VUE_APP_BASE_APP_URL);
const router = createRouter({
    base: process.env.VUE_APP_BASE_APP_URL,
    history: createWebHistory(process.env.VUE_APP_BASE_APP_URL),
    routes,
    mode:'history'
})

const store = createStore(stores)

const SUPPORTED_LANGS = ['en', 'tw', 'cn', 'vi', 'ja'];

/** 切換語系（i18n + vuex + Language singleton 三者同步） */
const switchLang = (lang) => {
    const targetLang = SUPPORTED_LANGS.includes(lang) ? lang : 'en';
    store.commit('setLang', targetLang);
    language.setLanguage(targetLang);
    i18n.global.locale = targetLang;
};

router.beforeEach((to, _from, next) => {
    if (to.name === 'main-lang') {
        switchLang(to.params.lang);
    }
    next();
});

let locale = 'en';

const browserLanguage = window.navigator.language
// alert(`browserLanguage=${browserLanguage}`)
if(browserLanguage.toLowerCase().indexOf('en')>=0){
    locale = 'en';
}else if(browserLanguage.toLowerCase().indexOf('tw')>=0){
    locale = 'tw';
}else if(browserLanguage.toLowerCase().indexOf('cn')>=0){
    locale = 'cn';
}else if(browserLanguage.toLowerCase().indexOf('vi')>=0){
    locale = 'vi';
}else if(browserLanguage.toLowerCase().indexOf('ja')>=0){
    locale = 'ja';
}
// locale = 'en';
console.log("locale", locale);
store.commit('setLang', locale);
language.setLanguage(locale);

const i18n = createI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en: en, // 英文翻譯消息
        tw: tw, // 繁體中文翻譯消息
        cn: cn, // 簡體中文翻譯消息
        vi: vi, // 越南文翻譯消息
        ja: ja // 越南文翻譯消息
    }
});



const user = new User(router);
const apiService = new ApiService(router);
const shared = new shareds();

const app = createApp(App);

app.config.globalProperties.$user = user;
app.config.globalProperties.$api = apiService;
app.config.globalProperties.$shared = shared;

//處理預設log事件
function patchConsole(type) {
  const original = console[type]

  console[type] = function (...args) {
    // 保留原功能
    original.apply(console, args)

    // 組合錯誤訊息字串
    // const logMsg = args.map(a => {
    //   if (a instanceof Error) return a.stack
    //   if (typeof a === 'object') {
    //     try {
    //       return JSON.stringify(a)
    //     } catch (e) {
    //       return '[Circular Object]'
    //     }
    //   }
    //   return a
    // }).join(' ')

    // 寫入 Vuex store
    // store.dispatch('addLog', `[${type.toUpperCase()}] ${logMsg}`)
  }
}
if ( process.env.VUE_APP_TEST_ENV == 'table' ){
    ['log', 'warn', 'error'].forEach(patchConsole)
}

app.use(router);
app.use(store);
app.use(i18n);
app.mount('#app');

// ✅ 加在這裡：全域錯誤與未捕捉 Promise 錯誤
window.onerror = function (message, source, lineno, colno, error) {
  store.dispatch('addLog', `[UNCAUGHT ERROR] ${message} at ${source}:${lineno}:${colno}`)
}

window.addEventListener('unhandledrejection', function (event) {
  store.dispatch('addLog', `[PROMISE REJECTION] ${event.reason}`)
})
  
